import styled from 'styled-components';
import CardWrapper from './CardWrapper';
import Wrapper from './Wrapper';
import UserInfoWrapper from './UserInfoWrapper';
import Notification, { NotificationLight } from './Notification';
import { ReloadButton } from './ReloadButton';
import { colors } from '../../../utils/utils';

export const Container = styled.div`
    position: relative;
    margin-top: 8px;
    width: 300px;
    align-content: center;
    align-items: center;
    box-shadow: 0 2px 6px 0 #cdd3df;
    border-radius: 4px;
    background: white;
    padding: 8px;
`;

/** Fills the space between the top of the trainer and the assistant chat dock. */
export const ScrollArea = styled.div`
    position: relative;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
`;

export const ScrollAreaInner = styled.div`
    position: absolute;
    inset: 0;
`;

export const TabMenu = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    gap: 2px;
`;

export const Tab = styled.div<{ $disabled?: boolean; $active?: boolean }>`
    font-size: 12px;
    font-weight: bold;
    flex: 1 1 0;
    min-width: 0;
    text-align: center;
    padding: 10px 4px 0 4px;
    color: ${props => {
        if (props.$disabled) {
            return colors.gray.jumbo;
        }
        if (props.$active) {
            return '#5d5ff9';
        }
        return '#333';
    }};
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &::after {
        content: '';
        display: block;
        margin: 4px auto 0 auto;
        width: 28px;
        border-radius: 4px 4px 0 0;
        height: 3px;
        background: ${props => (props.$active ? '#5d5ff9' : 'none')};
    }
`;

export const Separator = styled.hr`
    border: none;
    border-top: 1px solid #e8e8e8;
`;

export { CardWrapper, Wrapper, UserInfoWrapper, Notification, NotificationLight, ReloadButton };
